import { render, staticRenderFns } from "./DaysOnProjectTable.vue?vue&type=template&id=050941b4&scoped=true"
import script from "./DaysOnProjectTable.vue?vue&type=script&lang=ts"
export * from "./DaysOnProjectTable.vue?vue&type=script&lang=ts"
import style0 from "./DaysOnProjectTable.vue?vue&type=style&index=0&id=050941b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050941b4",
  null
  
)

export default component.exports